import { TransferStopsPayload } from "@mapmycustomers/shared/types/entity/Route";

import messages from "@app/scene/routes/component/RouteDetails/components/View/components/MoveStopsWizard/messages";

import formatMessage from "./formatMessage";

const modeAware403Message = (payload: TransferStopsPayload): string => {
  const descriptorByMode = {
    "copy-existing": messages.forbiddenCopyExisting,
    "copy-new": messages.forbiddenCopyNew,
    "move-existing": messages.forbiddenMoveExisting,
    "move-new": messages.forbiddenMoveNew,
  };
  const mode = `${payload.removeFromSource ? "move" : "copy"}-${payload.destination.mode}` as const;
  return formatMessage(descriptorByMode[mode]);
};

export default modeAware403Message;
